export default __webpack_public_path__ + "static/media/jewelry-clear-spring.c6f4271d.png";